import React from 'react';
import { useField } from 'react-final-form';
import CustomSelectConfig, { customFieldsConfig } from '../../../wallet-integration/components/customSelectConfig';

const PlaceBetPayoutConfig = (props) => {
  const {
    input: { value: implementationValue },
  } = useField('implementation');

  return customFieldsConfig.map((field) => (
    <CustomSelectConfig key={`brand-create-${field}`} source={field} implementation={implementationValue} {...props} />
  ));
};

export default PlaceBetPayoutConfig;
